import { getBusinessDataApi } from 'SupabseHandler';
import { businessData as businessDataAtom, businessId } from 'atoms';
import BusinessData from 'pages/Business/Business/BusinessData';
import EmptyBusinessHome from 'pages/Business/Business/EmptyBusinessHome';
import LocationHome from 'pages/Business/Location/LocationHome';
import { useRecoilState } from 'recoil';
import styled from 'styled-components';
import { sendEmail } from 'utils/methods';
import { useAuth } from 'context/AuthContext';

import React, { useEffect, useState } from 'react';

import BusinessPopup from './BusinessPopup';

const DataContainer = styled.div`
    background: ${(props) => props.theme.colorBackground};
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

const BusinessHome = () => {
    const { token, loading: authLoading } = useAuth();
    const [business, setBusiness] = useRecoilState(businessDataAtom);
    const [openPopup, setOpenPopup] = useState(false);

    const togglePopup = () => {
        setOpenPopup(!openPopup);
    };

    const getBusinessData = async (businessId) => {
        try {
            if (authLoading) {
                return; // Wait for auth to finish loading
            }
            if (!token) {
                console.error('No authentication token found');
                return;
            }
            const data = await getBusinessDataApi(businessId, token);
            setBusiness(data[0]);
        } catch (err) {
 
            setBusiness(err.message);
        }
    };

    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);

        if (business?.id !== undefined && !authLoading && token) {
            getBusinessData(business?.id).then();
        }
    }, [authLoading, token]);

    // const isBuisnessAdded = business?.business_url?.length > 0 && business?.email?.length>0 && business?.website_url?.length>0;

    const isBuisnessAdded = business?.email?.length > 0;
    return (
        <>
            {!isBuisnessAdded && (
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <EmptyBusinessHome togglePopup={togglePopup}></EmptyBusinessHome>
                    <LocationHome></LocationHome>
                </div>
            )}

            {business?.id > 0 && isBuisnessAdded && (
                <DataContainer>
                    <BusinessData data={business}></BusinessData>
                    <LocationHome></LocationHome>
                </DataContainer>
            )}

            <BusinessPopup open={openPopup} onClose={togglePopup}></BusinessPopup>
        </>
    );
};

export default BusinessHome;
